import { render, staticRenderFns } from "./infant.vue?vue&type=template&id=00558a6d&scoped=true&"
import script from "./infant.vue?vue&type=script&lang=js&"
export * from "./infant.vue?vue&type=script&lang=js&"
import style0 from "./infant.vue?vue&type=style&index=0&id=00558a6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00558a6d",
  null
  
)

export default component.exports